const Status = ({ status, onClick }) => {
  switch (status) {
    case "ACTIVE":
      return (
        <div
          className="campaign-status success text-link"
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
        >
          <span>Aktywna</span>
        </div>
      );
    case "PAUSED":
      return (
        <div
          className="campaign-status warning text-link"
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
        >
          <span>Wstrzymana</span>
        </div>
      );
    case "ARCHIVED":
      return (
        <div className="campaign-status danger">
          <span>Zarchiwizowna</span>
        </div>
      );
    default:
      return status;
  }
};

export default Status;
